import { useEffect } from "react";

export default function HamburguerMenu({ isOpen, toggleHamburguerMenu, scrollToGallery, visibleOpenHamburguer,scrollToRoadmap }) {

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = ""; 
        }
        return () => {
            document.body.style.overflow = ""; 
        };
    }, [isOpen]);

    return (
        <section>
            <div className="relative block lg:hidden inset-0 z-[10]">
                <div className={`gap-[5px] flex flex-col items-center justify-center absolute transition-all ${isOpen ? "h-[250px]" : "h-0"} bg-purple-750 w-full inset-0 z-[10] overflow-hidden duration-500`}>
                    <a className="text-28" target="_blank" href="https://instagram.com/hashguys.nft" rel="noreferrer">
                        Instagram
                    </a>
                    <div className="bg-[#151220] h-[2px] w-[340px]"></div>
                    <a className="text-28" target="_blank" href="https://x.com/hashguysnft" rel="noreferrer">
                        X (Twitter)
                    </a>
                    <div className="bg-[#151220] h-[2px] w-[340px]"></div>
                    <p onClick={scrollToGallery} className="text-28">
                        Gallery
                    </p>
                    <div className="bg-[#151220] h-[2px] w-[340px]"></div>
                    <p onClick={scrollToRoadmap} className="text-28">
                        Roadmap
                    </p>
                </div>
            </div>

            <div 
                className="bg-[#151220] block lg:hidden lg:bg-opacity-100 fixed block bg-opacity-50 h-[30000px] animate-fadeIn w-full inset-0 z-[1]"
                style={{ visibility: isOpen ? "visible" : "hidden" }}
            ></div>
        </section>
    );
}
